import { useState, useContext } from "react";
import Axios from "axios";
import Title from "./component/Title";
import GlobalContext from "./GlobalContext";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";

function Register() {
  const { globalURL } = useContext(GlobalContext);
  const url = globalURL;
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  Axios.defaults.withCredentials = true;

  const register = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    Axios.post(url + "/users/register-player", {
      firstname,
      lastname,
      phone,
      email,
    })
      .then((res) => {
        // Auto-login the new account.
        if (res.data?.token) {
          localStorage.setItem("token", res.data.token);
          localStorage.setItem("refresh", res.data.refreshToken);
        }
        enqueueSnackbar("Account created! You're signed in.", {
          variant: "success",
        });
        navigate("/account");
      })
      .catch((error) => {
        setErr(
          typeof error?.response?.data === "string"
            ? error.response.data
            : "Something went wrong"
        );
      })
      .finally(() => setLoading(false));
  };

  return (
    <div>
      <div className="container">
        <div className="bgRed sm:w-[85%] lg:w-[60%] relative flex justify-center flex-col items-center p-4 border-black border-8 rounded-3xl my-8 sm-shadow">
          <Title word="Sign Up" />
        </div>
        <div className="content my-8 justify-start items-center sm:w-[95%] lg:w-[80%] sm:pl-4 sm:pr-4 lg:pl-10 lg:pr-10 pt-10 pb-10 black-bg border-black border-8">
          <div className="flex flex-col gap-4 max-w-[320px]">
            <h1>Create your player account</h1>
            <p className="text-white/60 text-sm -mt-2">
              No password needed — you'll sign in with a code texted to your
              phone.
            </p>
            <form onSubmit={register} className="flex flex-col gap-3">
              <TextField
                label="First Name"
                required
                value={firstname}
                onChange={(e) => setFirstname(e.target.value)}
                autoComplete="given-name"
              />
              <TextField
                label="Last Name"
                required
                value={lastname}
                onChange={(e) => setLastname(e.target.value)}
                autoComplete="family-name"
              />
              <FormControl>
                <InputLabel id="phone-label">Mobile Phone</InputLabel>
                <OutlinedInput
                  label="Mobile Phone"
                  type="tel"
                  required
                  autoComplete="tel"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </FormControl>
              <FormControl>
                <InputLabel id="email-label">Email (optional)</InputLabel>
                <OutlinedInput
                  label="Email (optional)"
                  type="email"
                  autoComplete="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </FormControl>
              {err && (
                <strong className="text-red-500 text-center">{err}</strong>
              )}
              <Button variant="outlined" type="submit" disabled={loading}>
                {loading ? "Creating..." : "Create Account"}
              </Button>
              <Button variant="text" onClick={() => navigate("/login")}>
                Already have an account? Sign in
              </Button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register;
